import { ChatBubble } from '@hqo/react-components-library/dist/molecules/chat-bubble';
import styled from 'styled-components';

export const ChatBubbleStyled = styled(ChatBubble)`
  .error-text {
    white-space: nowrap;
  }
`;
